import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-new-folder-dialog',
  standalone: true,
  imports: [FormsModule, DialogModule, ButtonModule, InputTextModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog
      header="Új mappa létrehozása"
      [visible]="visible"
      (visibleChange)="onVisibleChange($event)"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <div style="display: flex; flex-direction: column; gap: 1rem; padding: 1rem 0">
        <p>Adja meg a mappa nevét.</p>
        <input
          pInputText
          type="text"
          placeholder="Mappa neve"
          [(ngModel)]="folderName"
          (keyup.enter)="submit()"
          style="width: 100%"
        />
      </div>
      <ng-template pTemplate="footer">
        <p-button label="MÉGSEM" styleClass="modal-btn--secondary" [text]="true" (onClick)="close()" />
        <p-button label="LÉTREHOZÁS" styleClass="modal-btn--primary" (onClick)="submit()" [disabled]="!folderName.trim()" />
      </ng-template>
    </p-dialog>
  `,
})
export class NewFolderDialog {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<string>();

  folderName = '';

  onVisibleChange(value: boolean): void {
    this.visible = value;
    if (!value) this.folderName = '';
    this.visibleChange.emit(value);
  }

  submit(): void {
    const trimmed = this.folderName.trim();
    if (!trimmed) return;
    this.confirm.emit(trimmed);
    this.onVisibleChange(false);
  }

  close(): void {
    this.onVisibleChange(false);
  }
}
